import React from "react";
import Helmet from "react-helmet";
import PostListing from "../components/PostListing/PostListing";
import SEO from "../components/SEO/SEO";
import Home from "../components/Home/Home";
import Banner from "../components/Banner/Banner"
import config from "../../data/SiteConfig";
import { Container, Row, Col, Visible, Hidden, ScreenClassRender } from 'react-grid-system';

class Index extends React.Component {
  render() {
    const postEdges = this.props.data.allMarkdownRemark.edges;
    return (
      <div className="index-container">
      <Helmet title={config.siteTitle} />
      <Banner />
      <Container>
        <Home />
        <SEO postEdges={postEdges} />
        <h2>Viimeisimmät kirjoitukset</h2>
        <PostListing postEdges={postEdges} />
        <h2>Miksi hakea lainaa?</h2>
        <p>Ihmiset hakevat lainaa monista syistä ja tämän takia lainojakin on olemassa useita erilaisia. Laina apu auttaa valitsemaan sinulle sopivimman lainan ja lainantajan. Käyttämällä lainanvälittäjää voit myös samanaikaisesti kilpailuttaa lainan usealla eri toimijalla. Tunnettujja lainoja ovat mm:</p>
        <ul><li>Asuntolaina</li>
        <li>Pikavippi</li>
        <li>Kulutusluotto</li>
        <li>Autolaina</li>
        <li>Vertaislaina</li></ul>
        <p>Useimmissa tapauksissa, ellei aina, asuntolaina on aina edullisin laina, jonka yksittäinen kuluttaja voi ottaa. Tämä johtuu yksinkertaisesti siitä, että asuntolainassa vakuusasia on kunnossa. Asunto takaa lainaa. Koko lainasummaa asuntokaan ei kuitenkaan takaa, useimmissa tilanteissa asunto takaa noin 70% ostohinnasta. Muut lainat myönnetään lähes aina heikommalla korolla, sillä vakuudet eivät ole yhtä vahvat. Pikavipit, vertaislainat sekä muut pikalainat ovat yleensä hyvin pitkälti kulutusluottoa. Ovathan ne kaikki kuitenkin lainaa, joka ohjautuu enemmän tai vähemmän suoraan kulutukseen. Näin ollen niiden hintakin on korkeampi kuin esimerkiksi asuntolainassa. Toki on muistettava, että nämä niin kutsut pikalainat myös maksetaan nopeammin takaisin kuin asuntolaina, joka yleensä otetaan vähintään 20 vuodeksi eteenpäin. Pikalainoja otetaan esimerkiksi silloin, kuin halutaan käydä lomalla <a target="_blank" rel="noopener" href="https://www.ulkomailla.fi/">ulkomailla</a>.</p>
        <h3>Kuka voi hakea lainaa?</h3>
        <p>Melkeinpä kaikilla suomalaisilla lainanantajilla on edelletys, että lainanhakija on suomalainen tai asuu vakituisesti Suomessa. Mikäli asut ulkomailla, et voi hakea lainaa Suomessa tai suomalaisilta toimijoilta. Lisäksi moni lainanantaja edellyttää seuraavia asioita:</p>
        <ul>
        <li>Vähintään 18-vuoden ikää - Usea toimija voi edellyttää myös 20 vuoden ikää</li>
        <li>Käytössä oleva matkapuhelinliittymä ja sähköposti</li>
        <li>Moitteetonta maksukäyttäytymistä. Maksuhäiriömerkintöjä ei saa olla.</li>
        </ul>
        <p>Edellä mainitut esimerkit ovat kuitenkin vain suuntaa antavia. Maksuhäiriömerkintöjä omaava henkilö pystyy hakemaan ja saaamaankin lainaa mikäli lainan vastineeksi voidaan laittaa jokin vakuus, esimerkiksi asunto.</p>
      </Container>
      </div>
    );
  }
}

export default Index;

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      limit: 3
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { category: { eq: "Blogi" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            cover
            date
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx